import { createRouter, createWebHashHistory } from "vue-router";
import AdminHomeView from "../components/AdminHome.vue"
import Home from "../views/Home.vue"
import PetIndex from "../views/pet/index.vue"
import YxbIndex from "../views/yxb/index.vue"
import SxzIndex from "../views/sxz/index.vue"
import { isAuthenticated, isPublicRoute } from "./auth"

const routes = [

    {
        path: "/",
        component: Home,
        children: [
        ]
    },
    {
        path: "/admin",
        component: AdminHomeView,
        children: [
            // 默认子路由：进入/admin时显示欢迎页
            {
                path: "",
                component: () => import("../components/Welcome.vue")
            },
            // 系统信息管理下的子路由
            {
                path: "fileTree", // 资源树查询
                component: () => import("../views/tools/source/ResourceTree.vue")
            },
            {
                path: "files", // 文件管理
                component: () => import("../views/tools/file/FilesView.vue")
            },
            {
                path: "catalogInfo", // 目录管理（仅管理员可见）
                component: () => import("../views/tools/catalog/CatalogInfo.vue")
            },
            {
                path: "sourceInfo", // 资源管理
                component: () => import("../views/tools/source/SourseInfo.vue")
            },
            {
                path: "addSource", // 资源新增
                component: () => import("../views/tools/source/AddSourse.vue")
            }


        ]
    },
    //寻宠物的
    {
        path: "/pet",
        component: PetIndex,
         children: [
            // 默认子路由：进入/admin时显示欢迎页
            {
                path: "",
                component: () => import("../components/Welcome.vue")
            },
            {
                path: "carousel", 
                component: () => import("../views/pet/carousel/CarouselView.vue")
            },
            {
                path: "stats", 
                component: () => import("../views/pet/stats/StatsView.vue")
            },
            {
                path: "users", 
                component: () => import("../views/pet/users/UsersView.vue")
            },
            {
                path: "infos", 
                component: () => import("../views/pet/info/InfoView.vue")
            },
            {
                path: "inform",
                component: () => import("../views/pet/inform/InformView.vue")
            },
            {
                path: "tokenorder",
                component: () => import("../views/pet/tokenorder/TokenOrderView.vue")
            },
            {
                path: "tokenpayerrorlog",
                component: () => import("../views/pet/log/TokenPayErrorLogView.vue")
            },
            {
                path: "toporder",
                component: () => import("../views/pet/toporder/TopOrderView.vue")
            },
            {
                path: "mediasec",
                component: () => import("../views/pet/mediasec/MediaSecView.vue")
            },
            {
                path: "files",
                component: () => import("../views/pet/file/PetFilesView.vue")
            },
            {
                path: "share-hongbao",
                component: () => import("../views/pet/sharehongbao/ShareHongbaoReceiveView.vue")
            }

        ]
    },
    // 邑学宝小程序后台
    {
        path: "/yxb",
        component: YxbIndex,
        children: [
            {
                path: "",
                component: () => import("../components/Welcome.vue")
            },
            {
                path: "lunbo",
                component: () => import("../views/yxb/lunbo/LunboView.vue")
            },
            {
                path: "uni-inform",
                component: () => import("../views/yxb/inform/UniInformView.vue")
            },
            {
                path: "community",
                component: () => import("../views/yxb/community/CommunityView.vue")
            },
            {
                path: "community-pictures",
                component: () => import("../views/yxb/pictures/CommunityPicturesView.vue")
            },
            {
                path: "users",
                component: () => import("../views/yxb/users/YxbUsersView.vue")
            },
            {
                path: "tongji",
                component: () => import("../views/yxb/tongji/TongjiView.vue")
            },
            {
                path: "data-console",
                component: () => import("../views/yxb/YxbDataConsoleView.vue")
            },
            {
                path: "files",
                component: () => import("../views/yxb/file/YxbFilesView.vue")
            },
            {
                path: "mediasec",
                component: () => import("../views/yxb/mediasec/YxbMediaSecView.vue")
            },
            {
                path: "news",
                component: () => import("../views/yxb/news/YxbNewsView.vue")
            }
        ]
    },
    // 韶小助小程序后台
    {
        path: "/sxz",
        component: SxzIndex,
        children: [
            {
                path: "",
                component: () => import("../components/Welcome.vue")
            },
            {
                path: "index-lunbo",
                component: () => import("../views/sxz/lunbo/SxzLunboView.vue")
            },
            {
                path: "users",
                component: () => import("../views/sxz/users/SxzUsersView.vue")
            },
            {
                path: "jianzhi",
                component: () => import("../views/sxz/jianzhi/SxzJianzhiView.vue")
            },
            {
                path: "jianzhi-pictures",
                component: () => import("../views/sxz/pictures/SxzJianzhiPicturesView.vue")
            },
            {
                path: "news",
                component: () => import("../views/sxz/news/SxzNewsView.vue")
            },
            {
                path: "comment",
                component: () => import("../views/sxz/comment/SxzCommentView.vue")
            },
            {
                path: "favorite",
                component: () => import("../views/sxz/favorite/SxzFavoriteView.vue")
            },
            {
                path: "text-sec-check",
                component: () => import("../views/sxz/textsec/SxzTextSecView.vue")
            },
            {
                path: "media-sec-check",
                component: () => import("../views/sxz/mediasec/SxzMediaSecView.vue")
            },
            {
                path: "button-switch",
                component: () => import("../views/sxz/buttonswitch/SxzButtonSwitchView.vue")
            },
            {
                path: "jianzhi-top-order",
                component: () => import("../views/sxz/toporder/SxzJianzhiTopOrderView.vue")
            },
            {
                path: "top-plan-config",
                component: () => import("../views/sxz/topplan/SxzTopPlanConfigView.vue")
            },
            {
                path: "pay-order",
                component: () => import("../views/sxz/payorder/SxzPayOrderView.vue")
            },
            {
                path: "errand-order",
                component: () => import("../views/sxz/errand/SxzErrandOrderView.vue")
            },
            {
                path: "errand-refund-apply",
                component: () => import("../views/sxz/errand/SxzErrandRefundApplyView.vue")
            },
            {
                path: "errand-accept",
                component: () => import("../views/sxz/errand/SxzErrandAcceptView.vue")
            },
            {
                path: "errand-deliver-proof",
                component: () => import("../views/sxz/errand/SxzErrandDeliverProofView.vue")
            },
            {
                path: "campus-auth",
                component: () => import("../views/sxz/campusauth/SxzCampusAuthView.vue")
            },
            {
                path: "withdraw-apply",
                component: () => import("../views/sxz/withdraw/SxzWithdrawApplyView.vue")
            },
            {
                path: "subscribe-message-log",
                component: () => import("../views/sxz/subscribelog/SxzSubscribeMessageLogView.vue")
            }
        ]
    },
    {
        path: "/share",
        name: "ShareMissingToken",
        component: () => import("../views/share/ResourceSharePublicView.vue"),
        meta: { public: true }
    },
    {
        path: "/share/:token",
        name: "ResourceSharePublic",
        component: () => import("../views/share/ResourceSharePublicView.vue"),
        meta: { public: true }
    },
    {
        path: "/library",
        name: "PublicLibrary",
        component: () => import("../views/public/PublicLibraryView.vue"),
        meta: { public: true }
    },
    {
        path: "/m/admin",
        component: () => import("../components/mobile/MobileAdminLayout.vue"),
        children: [
            {
                path: "",
                redirect: "/m/admin/fileTree"
            },
            {
                path: "fileTree",
                name: "MobileFileTree",
                component: () => import("../views/tools/source/ResourceTree.vue"),
                props: { isMobile: true }
            },
            {
                path: "addSource",
                name: "MobileAddSource",
                component: () => import("../views/tools/source/AddSourse.vue"),
                props: { isMobile: true }
            }
        ]
    },
    {
        path: "/login",
        component: () => import("../components/login.vue"),
        meta: { public: true }
    },
    {
        path: "/register",
        component: () => import("../components/register.vue"),
        meta: { public: true }
    }

]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    // 公开页：分享链接、资料库、登录注册、首页
    if (isPublicRoute(to) || to.path === '/') {
        next()
        return
    }
    if (isAuthenticated()) {
        next()
        return
    }
    next({
        path: '/login',
        query: { redirect: to.fullPath }
    })
})

export default router;